import { render, staticRenderFns } from "./relevance-form-modal.vue?vue&type=template&id=731ad71c&scoped=true"
import script from "./relevance-form-modal.vue?vue&type=script&lang=ts"
export * from "./relevance-form-modal.vue?vue&type=script&lang=ts"
import style0 from "./relevance-form-modal.vue?vue&type=style&index=0&id=731ad71c&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../entries/portal/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "731ad71c",
  null
  
)

export default component.exports